<template>
  <div class="filter" :class="{ 'open': isFilterOpen }">
    <div class="filter-body">
      <div class="row mb-0">
        <div class="col-md-4">
          <div class="filter__items">
            <div class="filter__item form-group">
              <label for="input-live">Менеджер</label>
              <b-form-input trim v-model="form.manager" placeholder="Имя или фамиля менеджера"></b-form-input>
            </div>
            <div class="filter__item form-group">
              <label for="input-live">Участник</label>
              <b-form-input trim v-model="form.member" placeholder="Фамилия участника"></b-form-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-footer">
      <b-button variant="primary" @click="onApplyFilter"><i class="icon-magnifier"></i> Найти</b-button>
      <b-button variant="light" @click="onResetFilter">Сбросить</b-button>
    </div>
  </div>
</template>
<script>
export default {
	data () {
		return {
			form: {
				manager: '',
				member: ''
			}
		}
	},
	props: {
		isFilterOpen: {
			type: Boolean,
			require: true
		}
	},
	methods: {
		onApplyFilter () {
			this.$emit('send', this.form)
		},
		onResetFilter () {
			this.clearForm()
		},
		clearForm () {
			this.form = {
				manager: '',
				member: ''
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/product/ProductMemberFilter.vue